import React from 'react';
import { type DrawerMenuItem } from '@cx-web/domain-types';
import classnames from 'classnames';

import { getCountriesWithSubdivisions } from '../utils/getCountriesWithSubdivisions';

import styles from './styles/MobileDropdown.module.css';

interface MobileStateDropdownProps {
  mobileHamburgerNav: DrawerMenuItem[];
  selectedState: string;
  setSelectedState: (state: string) => void;
  stateOptions: Array<{ code: string; label: string }>;
}

const MobileStateDropdown = ({
  mobileHamburgerNav,
  selectedState,
  setSelectedState,
  stateOptions,
}: MobileStateDropdownProps) => {
  const countries = getCountriesWithSubdivisions(mobileHamburgerNav);

  if (countries?.length === 0) {
    return null;
  }

  const supportedStateSet = new Set(stateOptions.map(state => state.code));

  return (
    <div className={styles.wrapper} data-testid="mobile-states">
      <div className={styles.stateButtons}>
        {countries.map(country => {
          const subdivisions = Object.entries(country.subdivisions)
            .filter(([code]) => supportedStateSet.has(code))
            .map(([code, details]) => ({ code, name: details.name }));

          if (!subdivisions.length) {
            return null;
          }

          return (
            <React.Fragment key={country.code}>
              <div className={styles.countryName} data-testid="country-title">
                {country.name}
              </div>
              <div className={styles.mobileGrid} data-testid="state-grid">
                {subdivisions.map(subdivision => {
                  return (
                    <button
                      className={classnames(styles.state, selectedState === subdivision.code ? styles.selected : '')}
                      key={subdivision.code}
                      onClick={() => setSelectedState(subdivision.code)}
                    >
                      {subdivision.name}
                    </button>
                  );
                })}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default MobileStateDropdown;
